export default "__VITE_ASSET__AQ_s7uC1__"